import ChatBotContainer from './ChatBotContainer';
import ChatBot from './ChatBot';
import FloatingChatButton from './FloatingChatButton';
import EmbeddedChatBot from './EmbeddedChatBot';

export { ChatBotContainer, ChatBot, FloatingChatButton, EmbeddedChatBot };
export default ChatBotContainer;
